import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Progress',
    props: {
        value: {
            type: Number,
            default: 0
        },
        backgroundColor: {
            type: String,
            default: '#b51f24'
        }
    }
});
